// Actions Types
export const FaqActionTypes = {
    ASYNC_LIST: '@faq/ASYNC_LIST',
    SET_LIST: '@faq/SET_LIST',
    LOADING_LIST: '@faq/LOADING_LIST',

    ASYNC_CREATE: '@faq/ASYNC_CREATE',
    ASYNC_UPDATE: '@faq/ASYNC_UPDATE',
    ASYNC_DELETE: '@faq/ASYNC_DELETE',

    LOADING_SAVE: '@faq/LOADING_SAVE',
    LOADING_DELETE: '@faq/LOADING_DELETE',

    SET_SELECTED: '@faq/SET_SELECTED',
    SET_LIST_PARAMS: '@faq/SET_LIST_PARAMS',
};

    const INITIAL_STATE = {
        items: [],
        total: 0,
        loadingList: true,
        loadingSave: false,
        loadingDelete: false,
        selected: null,
        listParams: {
            page: 0,
            pageSize: 10,
        },
    }


export const Faq = (state = INITIAL_STATE, { type, payload }) => {
    switch (type) {
        case FaqActionTypes.SET_LIST:
            return { ...state, items: payload?.items ?? [], total: payload?.total ?? 0 };
        case FaqActionTypes.LOADING_LIST:
            return { ...state, loadingList: payload };
        case FaqActionTypes.LOADING_SAVE:
            return { ...state, loadingSave: payload };
        case FaqActionTypes.LOADING_DELETE:
            return { ...state, loadingDelete: payload };
        case FaqActionTypes.SET_SELECTED:
            return { ...state, selected: payload };
        case FaqActionTypes.SET_LIST_PARAMS:
            return { ...state, listParams: { ...state.listParams, ...payload } };
        default:
            return state;
    }
}

export const asyncFaqList = (payload) => ({
    type: FaqActionTypes.ASYNC_LIST,
    payload,
});

export const setFaqList = (payload) => ({
    type: FaqActionTypes.SET_LIST,
    payload,
});

export const setFaqLoadingList = (payload) => ({
    type: FaqActionTypes.LOADING_LIST,
    payload,
});

export const setFaqLoadingSave = (payload) => ({
    type: FaqActionTypes.LOADING_SAVE,
    payload,
});

export const setFaqLoadingDelete = (payload) => ({
    type: FaqActionTypes.LOADING_DELETE,
    payload,
});

export const setFaqSelected = (payload) => ({
    type: FaqActionTypes.SET_SELECTED,
    payload,
});

export const setFaqListParams = (payload) => ({
    type: FaqActionTypes.SET_LIST_PARAMS,
    payload,
});

export const asyncFaqCreate = (payload) => ({
    type: FaqActionTypes.ASYNC_CREATE,
    payload,
});

export const asyncFaqUpdate = (payload) => ({
    type: FaqActionTypes.ASYNC_UPDATE,
    payload,
});

export const asyncFaqDelete = (payload) => ({
    type: FaqActionTypes.ASYNC_DELETE,
    payload,
});

export default Faq;